module.exports = __webpack_public_path__ + "img/user_friend_step3.556d56a1.svg";